<template>
  <div id="app">
    <router-view class="app"></router-view>
  </div>
</template>
<script>
  export default {
    name: 'app'
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";
  @import "index.scss";


  #app {
    height: 100%;
  }

  .app {
    background: #ffffff;
    min-width: 1280px;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// App.vue?3e458fd4